import InfoTab from './info/InfoTab';
import TutorialTab from './info/TutorialTab';
import AssistantTab from './info/AssistantTab';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { InfoPopUpModalData } from '../../utils/pageContent';

const InfoPopup = ({ open, handleClose, data, title }) => {
  const cancelButtonRef = useRef(null);
  const [type, setType] = useState('info');
  const [selectedContentArea, setSelectedContentArea] = useState('');

  const getData = useMemo(() => {
    return (
      selectedContentArea &&
      data?.tutorialsData?.find((item) => item?.areaName === selectedContentArea)
    );
  }, [selectedContentArea]);

  useEffect(() => {
    if (getData) {
      if (
        getData?.infoData?.title &&
        getData?.infoData?.subTitle &&
        getData?.infoData?.why &&
        getData?.infoData?.when &&
        getData?.infoData?.titleTips &&
        getData?.infoData?.faq?.length > 0
      ) {
        setType('info');
      } else if (
        getData?.tutorialsData?.title &&
        getData?.tutorialsData?.subTitle &&
        (getData?.tutorialsData?.videoUrl || getData?.tutorialsData?.imageUrl?.length > 0)
      ) {
        setType('tutorial');
      } else {
        setType('assistant');
      }
    }
  }, [getData]);

  useEffect(() => {
    if (data) {
      setType('info');
      setSelectedContentArea(data?.tutorialsData[0]?.areaName);
    }
  }, [data]);

  return (
    <Transition.Root appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity overflow-hidden" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full justify-end text-center items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-[76px]"
              enterTo="opacity-100 translate-y-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-100"
              leaveTo="opacity-0 translate-y-[76px]"
            >
              <Dialog.Panel className="relative transform overflow-hidden bg-transparent dark:border-none dark:text-shoorah-darkBg text-left shadow-xl transition-all mt-auto w-full">
                <button
                  onClick={() => handleClose()}
                  className="w-[30px] h-[30px] lg:w-10 lg:h-10 flex items-center justify-center relative bg-white dark:bg-shoorah-darkBg border border-shoorah-borderGray rounded-full cursor-pointer ml-auto mr-[18px] my-[15px]"
                >
                  <XMarkIcon width={20} height={20} className="dark:fill-shoorah-darkBgColor" />
                </button>
                <div className="md:min-h-[800px] min-h-[500px] w-full rounded-tr-[20px] rounded-tl-[20px] md:px-[50px] md:py-[52px] p-6 bg-white dark:bg-shoorah-darkBgColor dark:border-none border-[1.5px] border-shoorah-borderGray">
                  <div className="flex items-center md:gap-11 gap-8 lg:text-2xl text-xl border-b-[1.5px] border-black dark:border-shoorah-darkBg border-opacity-10 md:pb-[35px] pb-6 mb-6">
                    {getData?.infoData?.title &&
                      getData?.infoData?.subTitle &&
                      getData?.infoData?.why &&
                      getData?.infoData?.when &&
                      getData?.infoData?.titleTips &&
                      getData?.infoData?.faq?.length > 0 && (
                        <button
                          onClick={() => setType('info')}
                          className={`${
                            type === 'info'
                              ? 'text-black dark:text-shoorah-darkBg'
                              : 'text-black dark:text-shoorah-darkBg opacity-20'
                          } font-medium`}
                        >
                          {InfoPopUpModalData.infoBtnText}
                        </button>
                      )}
                    {getData?.tutorialsData?.title &&
                      getData?.tutorialsData?.subTitle &&
                      (getData?.tutorialsData?.videoUrl ||
                        getData?.tutorialsData?.imageUrl?.length > 0) && (
                        <button
                          onClick={() => setType('tutorial')}
                          className={`${
                            type === 'tutorial'
                              ? 'text-black dark:text-shoorah-darkBg'
                              : 'text-black dark:text-shoorah-darkBg opacity-20'
                          } font-medium`}
                        >
                          {InfoPopUpModalData.tutorialBtnText}
                        </button>
                      )}
                    {getData?.assistant && (
                      <button
                        onClick={() => setType('assistant')}
                        className={`${
                          type === 'assistant'
                            ? 'text-black dark:text-shoorah-darkBg'
                            : 'text-black dark:text-shoorah-darkBg opacity-20'
                        } font-medium`}
                      >
                        {InfoPopUpModalData.assistantBtnText}
                      </button>
                    )}
                  </div>

                  <div className="flex items-center gap-3 md:mb-8 mb-6 overflow-x-auto">
                    {data?.tutorialsData?.map((item, index) => {
                      return (
                        <button
                          key={index}
                          onClick={() => setSelectedContentArea(item.areaName)}
                          className={`relative border px-3 py-2 md:px-4 md:py-[14.5px] rounded-full text-sm font-medium disabled:opacity-70 flex items-center justify-center gap-3 cursor-pointer text-nowrap      ${
                            selectedContentArea === item.areaName
                              ? 'bg-shoorah-active border-shoorah-active text-white'
                              : 'text-shoorah-sidebarBackground border-[#B6C0F3] dark:border-transparent bg-white dark:text-white dark:bg-shoorah-darkBgTabColor'
                          }`}
                        >
                          <span>{item.areaName}</span>
                        </button>
                      );
                    })}
                  </div>

                  <>
                    {type === 'info' && <InfoTab data={getData?.infoData} title={title} />}
                    {type === 'tutorial' && (
                      <TutorialTab data={getData?.tutorialsData} title={title} />
                    )}
                    {type === 'assistant' && getData?.assistant && <AssistantTab title={title} />}
                  </>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default InfoPopup;
